"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Link;
(function (Link) {
    Link.configuration = {
        name: 'link',
        tagName: function () { return 'a'; },
        attrs: {
            href: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        getText: true,
        textMatcher: [
            {
                matcher: /\[(.*)\]\((.*)\)\s/,
                handler: function (match) {
                    return {
                        text: match[1],
                        href: match[2]
                    };
                }
            }
        ],
        parseDOM: [
            {
                tag: 'a[href]',
                getAttrs: function (dom) {
                    var text;
                    if (!dom.textContent && !dom.getAttribute('text')) {
                        return false;
                    }
                    // solve the problem of copying itself
                    text = dom.textContent || dom.getAttribute('text') || '';
                    return {
                        href: dom.getAttribute('href'),
                        text: text
                    };
                }
            }
        ],
        toDOM: function (node) {
            return ['a', { href: node.attrs.href }, node.attrs.text];
        }
    };
})(Link = exports.Link || (exports.Link = {}));
//# sourceMappingURL=link.js.map